import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './button';

interface FeaturedMethodologyProps {
  id: string;
  title: string;
  type: 'straight-up' | 'guided' | 'pathway';
  description?: string;
  className?: string;
}

const FeaturedMethodology: React.FC<FeaturedMethodologyProps> = ({
  id,
  title,
  type,
  description,
  className = ''
}) => {
  const navigate = useNavigate();
  
  const handleStartMethodology = () => {
    // Navigate to the appropriate methodology page
    if (type === 'guided') {
      navigate(`/guided-methodologies/${id}?newSession=true`);
    } else {
      navigate(`/methodology/${id}?newSession=true`);
    }
  };
  
  const getTypeLabel = () => {
    switch (type) {
      case 'straight-up':
        return 'Straight-up Methodology';
      case 'guided':
        return 'Guided Methodology';
      case 'pathway':
        return 'Pathway Methodology';
      default:
        return 'Methodology';
    }
  };
  
  return (
    <div className={`bg-[#f0f9e3] border-2 border-[#daed6e] rounded-[20px] p-5 shadow-sm hover:shadow-md transition-shadow relative ${className}`}>
      {/* Star positioned on the upper left corner */}
      <span 
        className="absolute -top-2 -left-2 text-lg flex items-center justify-center" 
        aria-label="Featured Methodology"
      >
        ⭐
      </span>
      
      <div className="flex justify-between items-start">
        <div>
          <h3 className="font-['Space_Grotesk'] font-bold text-lg text-black mb-1">
            {title}
          </h3>
          {description && (
            <p className="text-sm text-black opacity-80 mb-3">
              {description}
            </p>
          )}
          <div className="inline-block px-3 py-1 bg-[#daed6e] rounded-full text-xs font-medium">
            {getTypeLabel()}
          </div>
        </div>
        <Button 
          className="bg-[#daed6e] hover:bg-[#c5d85c] text-black font-medium px-4 h-10"
          onClick={handleStartMethodology}
        >
          Start Now
        </Button>
      </div>
    </div>
  );
};

export default FeaturedMethodology; 